import { jsxs as i, jsx as s } from "react/jsx-runtime";
import { InputElementTopSection as j } from "../components/input-element-top-section/input-element-top-section.js";
import r from "./text-area.module.less.js";
const v = ({
  label: l,
  helperText: c,
  errorText: a,
  name: e,
  placeholder: d,
  value: o,
  isValid: m,
  isDisabled: p,
  isReadOnly: f,
  maxLength: t = 120,
  minLength: h = void 0,
  onChange: x
}) => {
  const n = m === !1;
  return /* @__PURE__ */ i("div", { className: `${r.wrapper} space-mb-md`, children: [
    /* @__PURE__ */ s(
      j,
      {
        label: l,
        helperText: c,
        errorText: n && a ? a : void 0,
        htmlFor: e
      }
    ),
    /* @__PURE__ */ s(
      "textarea",
      {
        disabled: p,
        readOnly: f,
        className: [r.textArea, "font-family-preem-sans-new", n ? r.error : ""].join(" "),
        id: e,
        name: e,
        value: o,
        placeholder: d,
        onChange: (b) => x(b),
        minLength: h,
        maxLength: t
      }
    ),
    /* @__PURE__ */ s("div", { className: r.counterWrapper, children: /* @__PURE__ */ i("span", { className: [r.characterCounter, "body-s mb-0"].join(" "), children: [
      o?.length ?? 0,
      " / ",
      t
    ] }) })
  ] });
};
export {
  v as TextArea,
  v as default
};
